export const ExtraTypes = {
  AFFILIATION_FEE: 0,

  BAR_RESTAURANT: 1,

  RANGE: 2,

  EQUIPMENT: 3,

  INSURANCE: 4,

  VIRTUAL: 5,

  OTHER: 6,

  MEMBERSHIP_INSURANCE: 7,

  STARTER_FEE: 8,

  MANDATORY_RECURRING_FEE: 9,
};

/**
 * Helper function to check if extra is of specific type
 * @param {Object} extra - The extra object
 * @param {number} type - The type to check against
 * @returns {boolean}
 */
export const isExtraType = (extra, type) => extra && extra.Type === type;

/**
 * Helper function to check if extra is membership insurance
 * @param {Object} extra - The extra object
 * @returns {boolean}
 */
export const isMembershipInsurance = extra => isExtraType(extra, ExtraTypes.MEMBERSHIP_INSURANCE);

/**
 * Helper function to check if extra is starter fee
 * @param {Object} extra - The extra object
 * @returns {boolean}
 */
export const isStarterFee = extra => isExtraType(extra, ExtraTypes.STARTER_FEE);

/**
 * Helper function to check if extra is mandatory recurring fee
 * @param {Object} extra - The extra object
 * @returns {boolean}
 */
export const isMandatoryRecurringFee = extra => isExtraType(extra, ExtraTypes.MANDATORY_RECURRING_FEE);

export default ExtraTypes;
